import WeightType from "../../types/weight";

function transFontWeight({weight}: {weight: WeightType}) {
    let fontWeightValue = 500;
    if(weight === "thin" || weight === "xxs") { fontWeightValue = 100 }
    else if(weight === "light" || weight === "xs") { fontWeightValue = 200 }
    else if(weight === "regular" || weight === "sm") { fontWeightValue = 400 }
    else if(weight === "medium" || weight === "md") { fontWeightValue = 500 }
    else if(weight === "semibold" || weight === "lg") { fontWeightValue = 600 }
    else if(weight === "bold" || weight === "xl") { fontWeightValue = 700 }
    else if(weight === "extrabold" || weight === "xxl") { fontWeightValue = 800 }
    return fontWeightValue;
}

export default transFontWeight;